<template>
    <employment-doc-body
        v-model="form.fields"
        v-bind="{
            mode,
            pages,
        }"
        withoutReset
        @input="emit"
    >
        <template #head-left>
            <div style="max-width: 240px; margin: -5px -12px">
                <body-name v-model="form.name" @input="emit">
                    <body-file v-model="form.file" mode="button" @input="emit" />
                </body-name>
            </div>
        </template>
        <body-file v-model="form.file" @input="emit" />
    </employment-doc-body>
</template>

<script>
import { initEmploymentForm } from "@/assets/variables";

import BodyFile from "./body/body-file.vue";
import EmploymentDocBody from "@/components/console/employment/doc/employment-doc-body.vue";
import BodyName from "./body/body-name.vue";

export default {
    components: {
        BodyFile,
        EmploymentDocBody,
        BodyName,
    },
    props: {
        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },

        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentForm>} */
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        form: initEmploymentForm(),
    }),
    computed: {
        pages() {
            return this.form?.pages;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style></style>
